import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=ccdb8ccc&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdb8ccc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccdb8ccc')) {
      api.createRecord('ccdb8ccc', component.options)
    } else {
      api.reload('ccdb8ccc', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=ccdb8ccc&scoped=true&", function () {
      api.rerender('ccdb8ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yQIi04pO0KJp/JS/comp/Voucher-Unit.vue"
export default component.exports